import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hot", label: "热门吃瓜" },
  { href: "#categories", label: "视频分类" },
  { href: "#library", label: "视频库" },
  { href: "#columns", label: "深度吃瓜" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const light = !scrolled && !open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "border-b border-background-200/70 bg-background-50/90 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-chat-smile-3-fill text-lg" />
          </span>
          <span
            className={`font-heading text-xl tracking-wide ${
              light ? "text-background-50" : "text-primary-600"
            }`}
          >
            吃瓜<span className={light ? "text-accent-300" : "text-accent-500"}>视频在线</span>
          </span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm font-medium transition-colors hover:text-primary-500 ${
                light ? "text-background-100" : "text-foreground-700"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-bold transition-colors ${
              light
                ? "bg-accent-500 text-background-50 hover:bg-accent-600"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <i className="ri-notification-3-line text-[15px]" />
            订阅速递
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className={`flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${
            light ? "bg-background-50/15 text-background-50" : "bg-background-200 text-foreground-800"
          }`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-primary-50 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50"
            >
              <i className="ri-notification-3-line text-[15px]" />
              订阅吃瓜速递
            </a>
          </div>
        </div>
      )}
    </header>
  );
}